import apiClient from "@/api/apiClient";
import { spawnGetApiFunction, type ApiResourceConfig } from "@/utils/api";

import type { BucketFile, FileMetaInformation } from "@/utils/storage/types";

export const BUCKET_WORKSPACE_PROFILE_FILES = "workspace-profile-files";
const table = "workspace_profile_files";
const query = "*";

export const apiConfigWorkspaceProfileFiles: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: [],
  sortables: [],
};

export const getWorkspaceProfileFile = spawnGetApiFunction({ table, query });

export const createWorkspaceProfileFile = async ({
  workspace_id,
  file,
}: {
  workspace_id: string;
  file: FileMetaInformation;
}) => {
  const { data, error } = await apiClient
    .from(table)
    .insert({
      workspace_id,
      bucket_id: BUCKET_WORKSPACE_PROFILE_FILES,
      path: file.path,
      thumbnail: file.thumbnail,
    })
    .select(query)
    .maybeSingle();
  if (error) throw error;
  return data;
};
interface UpdateWorkspaceProfileFileProps {
  id: string;
  thumbnail?: string | null;
}
export const updateWorkspaceProfileFile = async ({ id, thumbnail }: UpdateWorkspaceProfileFileProps) => {
  const { data, error } = await apiClient
    .from(table)
    .update({
      thumbnail,
    })
    .match({
      id,
    })
    .select(query)
    .maybeSingle();
  if (error) throw error;
  return data;
};

export const deleteWorkspaceProfileFile = async (file: BucketFile) => {
  // we don't throw here since it doesn't affect the user if the file isn't successfully deleted (only db entity matters)
  await apiClient.storage.from(file.bucket_id).remove([file.path]);
  if (file.thumbnail) await apiClient.storage.from(file.bucket_id).remove([file.thumbnail]);
  const { error, ...rest } = await apiClient.from(table).delete().match({
    id: file.id,
  });
  if (error) throw error;
  return { error, ...rest };
};
